import React from 'react';
import { Helmet } from 'react-helmet';
import { Router } from '@reach/router';
import { AppHeader } from '@/components/AppHeader/AppHeader';
import { DemoModeStorageHandler } from '@/components/DemoModeStorageHandler/DemoModeStorageHandler';
import { NextAccountLoginPage } from '@/containers/NextAccountLogin/Page/NextAccountLoginPage';
import { SSOCallbackPage } from '@/containers/SSOCallback/Page/SSOCallbackPage';
import { SSOLoginPage } from '@/containers/SSOLogin/Page/SSOLoginPage';
import { SelectLoginMethodPage } from '@/containers/SelectLoginMethod/Page/SelectLoginMethodPage';
import { pathToLogin, pathToNextAccountLogin, pathToSSOLogin, pathToSSOCallback } from '@/helpers/route-helpers';

export const App: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>ジャストスマイル</title>
            </Helmet>
            <AppHeader />
            <Router>
                <DemoModeStorageHandler path="/">
                    <SelectLoginMethodPage default path={pathToLogin()} />
                    <NextAccountLoginPage path={pathToNextAccountLogin()} />
                    <SSOLoginPage path={pathToSSOLogin()} />
                    <SSOCallbackPage path={pathToSSOCallback()} />
                </DemoModeStorageHandler>
            </Router>
        </>
    );
};
